<template>
  <div>
    <div class="flex items-center text-base">
      <p class="truncate" :title="t['w.module.product_hero.customer_price']()">{{ t['w.module.product_hero.customer_price']() }}</p>
      <template v-if="discountPrice">
        <DiscountPercentage class="font-medium text-text-attention" :discount-percentage="discountPercentage" />
        <div class="ml-auto flex items-center pl-4">
          <Price :amount="regularPrice" large-fractional class="mr-1.5 text-lg text-text-light line-through" />
          <Price :amount="discountPrice" class="text-xl font-medium" />
        </div>
      </template>
      <Price v-else :amount="regularPrice" class="ml-auto pl-4 text-xl font-medium" />
    </div>
    <div v-if="virtualCreditPrice" class="mt-3 flex items-center text-base">
      <p class="truncate" :title="t['w.module.product_hero.loyal_customer_price']()">{{ t['w.module.product_hero.loyal_customer_price']() }}</p>
      <DiscountPercentage class="font-medium text-text-attention" :discount-percentage="virtualCreditDiscountPercentage" />
      <PricesTooltip :price="discountPrice ? discountPrice : regularPrice" :discount="!!discountPrice" :best-possible-price="virtualCreditPrice" />
      <Price :amount="virtualCreditPrice" class="ml-auto pl-4 text-xl font-medium text-text-strong" />
    </div>
    <div v-if="monthlyPayment">
      <div class="mt-3 flex items-center text-base">
        <p class="truncate" :title="t['w.module.product_hero.monthly_price']()">{{ t['w.module.product_hero.monthly_price']() }}</p>
        <button class="flex cursor-pointer items-center pl-2" @click="showMonthlyPaymentCalculator = !showMonthlyPaymentCalculator">
          <p class="truncate pr-1 text-sm font-semibold text-text-strong" :title="t['w.module.product_hero.monthly_calculate']()">
            {{ t['w.module.product_hero.monthly_calculate']() }}
          </p>
          <Icon class="size-5 origin-center transition-transform ease-in-out" :class="{ 'rotate-180 text-icon-active': showMonthlyPaymentCalculator }" name="chevron-down" />
        </button>
        <Price :amount="showMonthlyPaymentCalculator ? monthlyPaymentFromCalculator : monthlyPayment" class="ml-auto text-xl font-medium text-text-strong" />
      </div>
      <MonthlyPaymentCalculator v-show="showMonthlyPaymentCalculator" :sum="monthlyPaymentCalculatorSum" @kuumaks="monthlyPaymentFromCalculator = $event" />
      <p v-if="t['w.module.product_hero.monthly_price_info']()" class="mt-3 text-sm text-text-medium">{{ t['w.module.product_hero.monthly_price_info']() }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import Price from '~/components/price/Price.vue'
import DiscountPercentage from '~/components/price/DiscountPercentage.vue'
import MonthlyPaymentCalculator from './MonthlyPaymentCalculator.vue'
import PricesTooltip from '~/components/product/PricesTooltip.vue'
import Icon from '~/components/icon/Icon.vue'
import * as t from '~/messages'

const props = withDefaults(
  defineProps<{
    regularPrice?: number | null
    discountPrice?: number | null
    virtualCreditPrice?: number | null
    monthlyPayment?: number | null
    discountPercentage?: number | null
    virtualCreditDiscountPercentage?: number | null
    countryId?: number | null
  }>(),
  {
    regularPrice: null,
    discountPrice: null,
    virtualCreditPrice: null,
    monthlyPayment: null,
    discountPercentage: null,
    virtualCreditDiscountPercentage: null,
    countryId: null,
  }
)

const showMonthlyPaymentCalculator = ref<boolean>(false)
const monthlyPaymentFromCalculator = ref<number | null>(null)

const monthlyPaymentCalculatorSum = computed(() => {
  let smallestSum = props.regularPrice

  if (props.discountPrice && props.discountPrice < smallestSum) {
    smallestSum = props.discountPrice
  }

  if (props.virtualCreditPrice && props.virtualCreditPrice < smallestSum) {
    smallestSum = props.virtualCreditPrice
  }

  return smallestSum
})
</script>
